import i18n from "i18next";
import detector from "i18next-browser-languagedetector";

import { initReactI18next } from "react-i18next";

import XHR from "i18next-http-backend";

import translationEn from "@/locales/en/translation.json";
import translationIt from "@/locales/it/translation.json";

//translations

const resources = {
  it: { translation: translationIt},
  en: { translation: translationEn },

}

const detectionOptions = {
  order: [
      'htmlTag',
      'navigator'
  ],
  lookupQuerystring: 'lang'
}

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
      detection: detectionOptions,
      resources,
      ns: ['translation'],
      defaultNS: 'translation',
      fallbackLng: 'en',
      supportedLngs: [
          'it',
          'en',
      ],
      nonExplicitSupportedLngs: true,
      interpolation: {
          escapeValue: false,
      },
      debug: false
  });

export default i18n;



